import React from "react";
import clsx from "clsx";
// import { makeStyles } from "@mui/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Link from "@mui/material/Link";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { mainListItems, secondaryListItems } from "./components/SideBar.js";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
// import containerTheme from './theme/containerTheme.js'
import Company from './company';
import { useEffect, useState } from "react";
import DeleteIcon from '@mui/icons-material/Delete';
import { Row, Col, Card, Table, Alert } from "react-bootstrap";
import { appInsights } from './AppInsights';
import { useAuth0 } from '@auth0/auth0-react';
import Swal from 'sweetalert2';
import AADHeader from "./components/AADHeader.js";
export default function Home() {
  const username = localStorage.getItem("userName");
  const [isOpen, setIsOpen] = React.useState(true);
  const getOpen = (open) => {
    console.log(open)
    setIsOpen(open)
  } 
  const [countries, setCountries] = useState();
  const [tenantid, setTenantId] = useState();
  const [loading, setLoading] = React.useState(false);

  async function fetchData() {
    try {
      const response = await fetch('https://ecoprism-prod-node.azurewebsites.net/countries');
      const data = await response.json();
      setCountries(data);
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    appInsights.trackPageView();
    fetchData();
  }, []);

  const generatePassword = (length = 12) => {
    const uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz';
    const numbers = '0123456789';
    const specialCharacters = '!@#$%^&*()_-+=<>?/{}[]';
  
    const allCharacters = uppercaseLetters + lowercaseLetters + numbers + specialCharacters;
  
    let password = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * allCharacters.length);
      password += allCharacters.charAt(randomIndex);
    }
  
    return password;
  };

  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const countri = [country];
      let res = await fetch("https://ecoprism-prod-node.azurewebsites.net/create-company", {
        method: "POST",
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'username':username
        },
        body: JSON.stringify({
          name: entityname,
          revenue: revenue,
          countries:countri,
          numberOfEmployees:employees,
          adminEmail: adminemail,
          adminName: adminname,
          authenticationType:authtype,
          tenants:[tenantid]
        })
      });
      if (res.status === 200) {
        const responseJson1 = await res.json();
        if(responseJson1.success === false){
          setLoading(false);
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: "User already exist"
          });
        }
        else if(responseJson1.status === 400){
          setLoading(false);
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: responseJson1.title
          });
        }
        else{
          const loginType = localStorage.getItem('loginType');
          if(loginType === 'AAD'){
            setLoading(false);
            Swal.fire({
              icon: 'success',
              html: "Company created successfully",
              iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
            
            });
          }
          else{
            let token = await fetch("https://ecoprism-prod-node.azurewebsites.net/GetAuth0Token", {
              method: "POST",
              headers: {
                'Content-type': 'application/x-www-form-urlencoded'
              },
              body:JSON.stringify({
                "grant_type":"client_credentials",
                "audience":"https://dev-bzvpxk64kwf4dxfs.us.auth0.com/api/v2/"
              })
            });
            if (token.status === 200) {
              const responseToken = await token.json();
              const accessToken=responseToken.access_token;
              const newPassword = generatePassword();
              let accessRes = await fetch("https://ecoprism-prod-node.azurewebsites.net/CreateUser", {
                method: "POST",
                headers: {
                  'Content-type': 'application/json',
                  'token':accessToken
                },
                body: JSON.stringify({
                  "email": adminemail,
                  "given_name": entityname,
                  "family_name": entityname,
                  "name": entityname,
                  "nickname": entityname,
                  "connection": "Username-Password-Authentication",
                  "password": newPassword
                })
              });
              if (accessRes.status === 200) {
                const accessresponseJson = await accessRes.json();
              }
            }
            setLoading(false);
            Swal.fire({
              icon: 'success',
              html: "Company created successfully",
              iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
            
            });
          }
          
          
        }
      }
      else{
        setLoading(false);
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'SOmething went wrong'
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  
  const [entityname, setEntityName] = useState("");
  const [revenue, setRevenue] = useState("");
  const [country, setCountry] = useState("");
  const [employees, setEmployees] = useState("");
  const [adminname, setAdminName] = useState("");
  const [adminemail, setAdminEmail] = useState("");
  const [authtype, setauthenticationType] = useState("");
  const [message, setMessage] = useState("");
  const renderHeader2 = () => {
    const loginType = localStorage.getItem('loginType');
    if (loginType === 'AAD') {
      return <AADHeader />;
    }
    return <LoginHeader heading="" />;
  };
  return (
    <div id="wrapper">
 
    <div id="sidebar-wrapper" className={isOpen ? "sidebar-open" : "sidebar-close" }>
        <SideNavigation getOpen={getOpen}/>        
    </div>
    <div id="page-content-wrapper" className={isOpen ? "" : "page-content-wrapper-pd-0" }>
    {renderHeader2()}
      <div class="container">
          <div class="col-md-12">
            <div Class="steps__containt-hader">
              <h3 class="title">Add New Company</h3>
            </div>
            {message && <Alert variant="success">{message}</Alert>}
            <form onSubmit={handleSubmit}>
  <div className="form-row">
    <div className="form-group col-md-6">
      <label className="formlable" htmlFor="inputcompany">Company Name</label>
      <input 
        type="text" 
        value={entityname} 
        onChange={(e) => setEntityName(e.target.value)} 
        className="form-control" 
        placeholder="Enter company name"
      />
    </div>
    <div className="form-group col-md-6">
      <label className="formlable" htmlFor="inputState">Country</label>
      <select 
        id="inputState" 
        className="form-control" 
        value={country}  
        onChange={(e) => setCountry(e.target.value)}
      >
        <option selected value="">Select Country</option>
        {countries && countries.map((status) => (
          <option key={status} value={status}>{status}</option>
        ))}
      </select>
    </div>
  </div>
  <div className="form-row">
    <div className="form-group col-md-6">
      <label className="formlable" htmlFor="inputCity">Admin Email</label>
      <input 
        type="text" 
        value={adminemail} 
        onChange={(e) => setAdminEmail(e.target.value)} 
        className="form-control" 
        id="inputCity" 
        placeholder="Enter Admin Email"
      />
    </div>
    <div className="form-group col-md-6">
      <label className="formlable" htmlFor="inputZip">Admin Name</label>
      <input 
        type="text" 
        value={adminname} 
        onChange={(e) => setAdminName(e.target.value)} 
        className="form-control" 
        id="inputZip" 
        placeholder="Enter Admin Name"
      />
    </div>
  </div>
  <div className="form-row">
    <div className="form-group col-md-6">
      <label className="formlable" htmlFor="inputCity">Revenue</label>
      <input 
        type="text" 
        value={revenue} 
        onChange={(e) => setRevenue(e.target.value)} 
        className="form-control" 
        id="inputCity" 
        placeholder="Enter Company Revenue"
      />
    </div>
    <div className="form-group col-md-6">
      <label className="formlable" htmlFor="inputZip">No. of Employees</label>
      <input 
        type="text" 
        value={employees} 
        onChange={(e) => setEmployees(e.target.value)} 
        className="form-control" 
        id="inputZip" 
        placeholder="No. of Employees"
      />
    </div>
  </div>
  <div className="form-row">
    <div className="form-group col-md-6">
      <label className="formlable" htmlFor="inputState">Authentication Type</label>
      <select 
        id="inputState" 
        className="form-control" 
        value={authtype}  
        onChange={(e) => setauthenticationType(e.target.value)}
      >
        <option selected value="">Select Authentication Type</option>
        <option value="Auth0">Auth0</option>
        <option value="AAD">AAD (Microsoft)</option>
      </select>
    </div>
    {authtype === "AAD" && (
      <div className="form-group col-md-6">
        <label className="formlable" htmlFor="inputState">Tenant Id</label>
        <input 
          type="text" 
          value={tenantid} 
          onChange={(e) => setTenantId(e.target.value)} 
          className="form-control" 
          id="inputZip" 
          placeholder="Enter Tenant Id"
        />
      </div>
    )}
  </div>
  <button type="submit" className="btn btn-primary signin__btn">Submit</button>
</form>

            
          </div>
          
      </div>
    </div>
    

</div>
  );
}
